<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-col cols="12" sm="12" md="12">
            <v-card class="box">
                <v-toolbar flat dense class="toolbar no-display">
                    <v-toolbar-title>Upload Course Image</v-toolbar-title>
                </v-toolbar>
                <v-row dense justify="center">
                    <v-col sm="3" v-if="course_list != null">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="crs_id" item-value="id"
                            :items="course_list" item-text="crs_name" label="Subject" outlined />
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-icon color="error">*</v-icon>
                        <v-text-field color="#0F2027" dense rounded outlined label="Sort Order"
                            v-model.trim="sort_order" type="number" required></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-icon color="error">*</v-icon>
                        <v-file-input v-model="file" dense rounded outlined id="file" prepend-icon="mdi-attachment"
                            label="Choose File" show-size accept="image/*"></v-file-input>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="pt-5">
                        <v-btn class="button" :loading="loading" v-if="sort_order && file && crs_id"
                            @click="uploadimage(crs_id, sort_order, file, 'new')">Save</v-btn>
                    </v-col>
                </v-row>
                <v-toolbar v-if="course_image_list != ''" flat dense class="toolbar no-display">
                    <v-toolbar-title>Course Images</v-toolbar-title>
                </v-toolbar>
                <br />
                <v-row dense>
                    <v-col cols="12" sm="3" md="3" v-if="course_list != null">
                        <v-autocomplete dense rounded outlined v-model="selectedCourse" :items="course_list"
                            item-value="id" item-text="crs_name" label="Course"></v-autocomplete>
                    </v-col>
                </v-row>


                <!-- <v-data-table v-if="course_image_list != ''" :headers="headers" :items="course_image_list" -->
                <v-data-table v-if="course_image_list != ''" :headers="headers" :items="filteredCourseImages"
                    class="elevation-1 mytable" dense>
                    <template v-slot:item.action="{ item }">
                        <v-btn small class="button pt-0 pb-0" :loading="loading"
                            @click="uploadimage(item.crs_id, item.sort_order, item.file_edit, 'edit')">Update</v-btn>
                    </template>
                    <template v-slot:item.sort_order="{ item }">
                        <v-text-field class="pt-2" outlined dense type="number" v-model="item.sort_order"
                            label="Edit Sort Order" hint="Sort Order" rounded></v-text-field>
                    </template>
                    <template v-slot:item.delete="{ item }">
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon color="red" @click="deletedialog_image(item.id)" v-bind="attrs"
                                    v-on="on">mdi-delete-circle</v-icon>
                            </template>
                            <span>
                                Delete uploaded File!!!
                            </span>
                        </v-tooltip>
                    </template>
                    <template v-slot:item.image_view="{ item }">
                        <!-- <a class="p-2" :href="aws_path + item.file_path + item.file_name" target="blank">
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon v-bind="attrs" v-on="on"> <v-icon color="black">mdi-eye</v-icon></v-btn>
                                </template>
                                <span>
                                    View File!!!
                                </span>
                            </v-tooltip>
                        </a> -->
                        <v-avatar size="70" rounded="0">
                            <img :src="aws_path + item.file_path + item.file_name" alt="Course Image" />
                        </v-avatar>
                    </template>
                    <template v-slot:item.image="{ item }">
                        <v-file-input class="pt-2" v-model="item.file_edit" dense rounded outlined id="file"
                            prepend-icon="mdi-attachment" label="Choose File" show-size accept="image/*"></v-file-input>
                    </template>
                </v-data-table>
            </v-card>
            <v-dialog v-model="delete_dialog" persistent max-width="500px">
                <v-card>
                    <v-container>
                        <v-card class="box">
                            <input type="hidden" v-model="delete_id" />
                            <strong>Are you sure you want Delete this file???</strong>
                            <v-row justify="center">
                                <v-btn class="button" text @click="delete_dialog = false">No</v-btn>
                                <v-btn class="button" text @click="deletefile()">Yes</v-btn>
                            </v-row>
                        </v-card>
                    </v-container>
                </v-card>
            </v-dialog>
        </v-col>
    </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard

import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {
    components: {
        Breadcrumbs,
    },
    data() {
        return {
            snackbar_msg: null,
            // extraBreadcrumbItems: [


            // ],
            // breadcrumbClass: "breadcrumb-style1",
            snackbar: false,
            color: "",
            overlay: false,
            course_list: [],
            crs_id: null,
            course_image_list: [],
            sort_order: 0,
            file: null,
            loading: false,
            aws_path: null,
            selectedCourse: null,
            delete_dialog: false,
            delete_id: null,
            headers: [
                {
                    text: "Course",
                    align: "left",
                    sortable: false,
                    value: "crs_name",
                },
                {
                    text: "Uploaded Course Image",
                    align: "left",
                    sortable: true,
                    value: "image_view",
                },
                {
                    text: "Sort Order",
                    align: "left",
                    sortable: true,
                    value: "sort_order",
                },
                {
                    text: "Upload New Course Image",
                    align: "left",
                    sortable: true,
                    value: "image",
                },
                { text: "Actions", value: "action", sortable: false },
                { text: "Delete", value: "delete", sortable: false },
            ],
        };
    },
    created() {
        this.aws_path = localStorage.getItem("awspath");
    },
    mounted() {
        this.onload();
    },
    computed: {
        filteredCourseImages() {
            if (!this.selectedCourse) {
                return this.course_image_list;
            }
            return this.course_image_list.filter(
                (item) => item.crs_id === this.selectedCourse
            );
        },
    },
    methods: {
        async deletefile() {
            const data = {
                id: this.delete_id
            }
            try {
                const res = await axios.post("/WWSExamination/deleteCourseImage", data);
                if (res.data.flag == "YES") {
                    this.showSnackbar("success", "File deleted Successfully");
                    this.delete_dialog = false;
                    this.onload();
                } else {
                    this.showSnackbar("red", res.data.snackbar);
                    sessionStorage.setItem("error-trace", res.data.error_trace);
                }
            } catch (err) {
                this.onerror(err);
            } finally {
                console.log("bye...");
            }
        },
        deletedialog_image(id) {
            this.delete_id = id;
            this.delete_dialog = true;
        },
        async getCourse() {
            try {
                const res = await axios.post("/WWSExamination/getCourseList");
                if (res.data.flag == "YES") {
                    this.course_list = res.data.course_list;
                } else {
                    this.showSnackbar("red", res.data.snackbar);
                    sessionStorage.setItem("error-trace", res.data.error_trace);
                }
            } catch (err) {
                this.onerror(err);
            } finally {
                console.log("bye...");
            }
        },
        async uploadimage(crs_id, sort_order, file, type) {
            if (sort_order < 0) {
                this.showSnackbar("red", "Please Enter Valid Sort Order");
                return
            }
            let formData = new FormData();
            this.loading = true;
            formData.append("crs_id", crs_id);
            formData.append("sort_order", sort_order);
            formData.append("file", file);
            formData.append("type", type);
            try {
                const res = await axios.post("/WWSExamination/saveCourseImageList", formData, {});
                if (res.data.flag == "YES") {
                    this.onload();
                } else {
                    this.showSnackbar("red", res.data.snackbar);
                    sessionStorage.setItem("error-trace", res.data.error_trace);
                }
                this.loading = false;
            } catch (err) {
                this.onerror(err);
                this.loading = false;
            } finally {
                console.log("bye...");
                this.loading = false;
                this.file = null;
            }
        },
        onerror(error) {
            let msg = "";
            if (error.response) {
                msg = "Something went wrong.";
            } else if (error.request) {
                msg = "Please try again.";
            } else {
                msg = "Un-expected error.";
            }
            this.showSnackbar("error", msg);
        },

        async onload() {
            this.overlay = true;
            try {
                const res = await axios.post("/WWSExamination/getCourseImageList");
                if (res.data.flag == "YES") {
                    this.course_image_list = res.data.course_image_list;
                    this.getCourse();
                    this.overlay = false;
                } else {
                    this.showSnackbar("red", res.data.snackbar);
                    sessionStorage.setItem("error-trace", res.data.error_trace);
                }
                this.overlay = false;
            } catch (err) {
                this.onerror(err);
                this.overlay = false;
            } finally {
                console.log("bye...");
                this.overlay = false;
            }
        },

        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
    },
};
</script>
<style scoped>
.delete-avatar {
    transition: 0.3s;
    border: 1px solid red;
    margin: 0.2rem !important;
}

.delete-avatar:hover {
    background-color: transparent;
}

.delete-v-icon {
    padding-left: 8px;
    padding-top: 1px;
    font-size: 15px;
}

.delete-v-icon:hover {
    color: white;
}

.edit-avatar {
    transition: 0.3s;
    border: 1px solid #0f2027 !important;
    margin: 0.2rem !important;
}

.edit-avatar:hover {
    background-color: transparent;
}

.edit-v-icon {
    padding-left: 6px;
    font-size: 15px;
}

.edit-v-icon:hover {
    color: white;
}
</style>
